import request from "@/router/axios"; //引入封装的axios，也就是步骤一中的axios文件

//发送post请求
export const login = (params) => {
  return request({
    url: "/api/login",
    method: "post",
    data: params
  });
};